module.exports = __webpack_public_path__ + "FixelDisplay-ExtraLightItalic-64401a51ea09901ba7b2e8bd8932154d.woff2";